import * as React from "react";
import { cn } from "../../lib/utils";

export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-[1.5rem] border border-black/10 bg-white/85 p-5 shadow-[0_16px_42px_rgba(16,32,26,0.08)] backdrop-blur-xl transition hover:border-pink/40 hover:bg-white",
        className,
      )}
      {...props}
    />
  );
}

